angular.module('TetherApp').directive('tetherText', function () {
    return {
        restrict: 'E',
        templateUrl: '/html/form/tetherText.html'
    }
});
